import Slider from './Slider';
import withLocale from '../IntlProvider/withLocale';
export default withLocale([])(Slider);